import { render, staticRenderFns } from "./DocumentContents.vue?vue&type=template&id=74050570&scoped=true&lang=pug"
import script from "./DocumentContents.vue?vue&type=script&lang=js"
export * from "./DocumentContents.vue?vue&type=script&lang=js"
import style0 from "./DocumentContents.vue?vue&type=style&index=0&id=74050570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74050570",
  null
  
)

export default component.exports